const colors = ['#33638D','#54C667','#6a1b9a','#FF8900']

function getRandomNumber(min: number, max: number, round:boolean = false) { 
  let num = Math.random() * (max - min) + min;
  round && (num = Math.round(num))
  return num
} 

const changeDataAlterPoints = data => {

let newY = [80,120,getRandomNumber(100,200),getRandomNumber(120,250),getRandomNumber(180,270),290,500]

return ([{...data[0],
  x: [1,2,3,3,4,4,5],
  y: newY,
  marker: { 
    size:15,
    color: newY.map(i => (colors[i<150? 0 : 1])),
    line: {
      color: '#fff',
      width: 1
  }},
  }])

}

// later, for logistic regression maybe (or for testing purposes)
/*export const markerDataInteractive = {
  data: Object.keys(dataXMarkersOnly).map((key, index) => ({
    x: dataX[key],
    y: dataY[key],
    type: `scatter`,
    mode: modes[key],
    name: key,
    showlegend: false,
    hoverlabel: {
      font: {color: threeFunctionTextColors[key]}
    },
    hovertemplate:
            "price: %{y}k<br>" +
            "#bedrooms: %{x}<br>" +
            "<extra></extra>",
    marker: { 
      size:15,
      color: colors[index],
      line: {
        color: '#fff',
        width: 1
    }},
  })),
  props: {
    yAxisTitle: "price in thousand $",
    xAxisTitle: "number of bedrooms",
    plotTitle: "Housing Prices",
    changeDataFunction: changeDataAlterPoints
  }
}*/

const polynomialDataX = [ 1,  4,  5,  7,  9, 23, 25, 25, 26, 28, 31, 32, 33, 33, 34, 36, 38,
  39, 43, 47, 47, 48, 48, 50, 52, 54, 56, 57, 57, 59]

const polynomialDataY = [ 52.6011713 ,  27.12578382,  47.22505012,   9.93698207,
  15.28949685,   2.77217121,  20.6887531 ,  20.18138954,
  12.21805904,  19.95970689,  20.54878299,  15.74740062,
  32.89047517,  36.92456412,  49.70296068,  58.04850084,
  53.94644706,  58.87164134,  68.73365311,  78.38707417,
  76.09705614, 100.        ,  88.13917882,  92.68938221,
  88.77347522, 100.        ,  86.69455229,  97.17807465,
  90.62591825,  99.43804976]

const polynomialModes = {
  markers: "markers",
  lines: "lines" 
}

const polynomialPredsXTest = {1: [1.219, 2.744, 4.27, 5.796, 7.321, 8.847, 10.373, 11.898, 13.424, 14.95, 16.475, 18.001, 19.526, 21.052, 22.578, 24.103, 25.629, 27.155, 28.68, 30.206, 31.731, 33.257, 34.783, 36.308, 37.834, 39.36, 40.885, 42.411, 43.936, 45.462, 46.988, 48.513, 50.039, 51.565, 53.09, 54.616, 56.141, 57.667, 59.193, 60.718, 62.244, 63.77, 65.295, 66.821, 68.346, 69.872, 71.398, 72.923, 74.449, 75.975, 77.5, 79.026, 80.551, 82.077, 83.603, 85.128, 86.654, 88.18, 89.705, 91.231, 92.756], 2: [34.33, 32.768, 31.308, 29.949, 28.691, 27.535, 26.481, 25.528, 24.677, 23.927, 23.279, 22.732, 22.287, 21.944, 21.702, 21.561, 21.523, 21.585, 21.75, 22.015, 22.383, 22.852, 23.422, 24.094, 24.867, 25.742, 26.719, 27.797, 28.977, 30.258, 31.641, 33.125, 34.711, 36.399, 38.188, 40.078, 42.07, 44.164, 46.359, 48.656, 51.054, 53.554, 56.155, 58.858, 61.663, 64.569, 67.576, 70.685, 73.896, 77.208, 80.622, 84.137, 87.754, 91.473, 95.292, 99.214, 100.0, 100.0, 100.0, 100.0, 100.0], 3: [64.296, 55.988, 48.342, 41.339, 34.959, 29.185, 23.997, 19.377, 15.305, 11.763, 8.733, 6.195, 4.13, 2.52, 1.346, 0.59, 0.231, 0.253, 0.635, 1.359, 2.406, 3.758, 5.395, 7.3, 9.452, 11.833, 14.425, 17.208, 20.165, 23.275, 26.521, 29.883, 33.342, 36.881, 40.479, 44.119, 47.781, 51.447, 55.098, 58.715, 62.279, 65.772, 69.174, 72.467, 75.632, 78.651, 81.504, 84.173, 86.638, 88.882, 90.885, 92.629, 94.094, 95.262, 96.114, 96.632, 96.796, 96.588, 95.989, 94.98, 93.542], 4: [59.829, 52.914, 46.473, 40.5, 34.99, 29.938, 25.337, 21.18, 17.461, 14.171, 11.302, 8.846, 6.793, 5.135, 3.861, 2.96, 2.423, 2.237, 2.39, 2.871, 3.666, 4.764, 6.148, 7.807, 9.725, 11.887, 14.278, 16.882, 19.682, 22.661, 25.803, 29.09, 32.502, 36.023, 39.631, 43.309, 47.036, 50.79, 54.553, 58.301, 62.013, 65.667, 69.24, 72.709, 76.049, 79.237, 82.249, 85.059, 87.641, 89.969, 92.018, 93.76, 95.168, 96.213, 96.869, 97.105, 96.893, 96.203, 95.005, 93.268, 90.961], 5: [59.61, 52.789, 46.42, 40.5, 35.028, 29.999, 25.41, 21.256, 17.532, 14.231, 11.348, 8.875, 6.804, 5.127, 3.835, 2.917, 2.364, 2.164, 2.307, 2.78, 3.57, 4.665, 6.051, 7.713, 9.638, 11.808, 14.21, 16.826, 19.64, 22.634, 25.791, 29.093, 32.521, 36.055, 39.677, 43.366, 47.102, 50.864, 54.631, 58.381, 62.093, 65.743, 69.309, 72.768, 76.096, 79.27, 82.266, 85.058, 87.622, 89.933, 91.965, 93.693, 95.09, 96.131, 96.788, 97.035, 96.845, 96.19, 95.042, 93.375, 91.159], 6: [62.199, 53.7, 46.27, 39.779, 34.11, 29.161, 24.847, 21.093, 17.836, 15.023, 12.611, 10.564, 8.854, 7.459, 6.363, 5.553, 5.021, 4.76, 4.769, 5.044, 5.586, 6.393, 7.466, 8.803, 10.402, 12.26, 14.372, 16.732, 19.329, 22.154, 25.192, 28.427, 31.841, 35.413, 39.119, 42.933, 46.827, 50.773, 54.737, 58.689, 62.593, 66.416, 70.123, 73.681, 77.057, 80.219, 83.139, 85.79, 88.15, 90.201, 91.931, 93.332, 94.407, 95.164, 95.621, 95.806, 95.761, 95.536, 95.199, 94.831, 94.529], 7: [56.98, 52.465, 47.269, 41.729, 36.112, 30.627, 25.435, 20.65, 16.35, 12.586, 9.381, 6.738, 4.646, 3.083, 2.016, 1.41, 1.224, 1.42, 1.958, 2.801, 3.916, 5.274, 6.849, 8.621, 10.574, 12.697, 14.98, 17.419, 20.012, 22.757, 25.655, 28.705, 31.906, 35.255, 38.747, 42.371, 46.114, 49.958, 53.88, 57.851, 61.836, 65.796, 69.688, 73.464, 77.073, 80.463, 83.583, 86.384, 88.822, 90.863, 92.481, 93.67, 94.443, 94.838, 94.924, 94.809, 94.645, 94.636, 95.046, 96.21, 98.541], 8: [56.39, 52.386, 47.424, 41.941, 36.282, 30.712, 25.426, 20.561, 16.211, 12.427, 9.233, 6.628, 4.594, 3.099, 2.105, 1.568, 1.442, 1.683, 2.25, 3.104, 4.211, 5.544, 7.081, 8.804, 10.702, 12.766, 14.992, 17.381, 19.931, 22.646, 25.527, 28.574, 31.787, 35.161, 38.687, 42.355, 46.146, 50.039, 54.006, 58.015, 62.029, 66.004, 69.895, 73.655, 77.232, 80.578, 83.644, 86.387, 88.769, 90.762, 92.349, 93.529, 94.319, 94.758, 94.91, 94.873, 94.774, 94.785, 95.118, 96.035, 97.851], 9: [40.489, 51.843, 52.121, 46.515, 38.537, 30.417, 23.432, 18.177, 14.777, 13.06, 12.686, 13.244, 14.324, 15.563, 16.671, 17.447, 17.781, 17.645, 17.084, 16.198, 15.128, 14.034, 13.084, 12.435, 12.222, 12.551, 13.491, 15.071, 17.284, 20.084, 23.397, 27.126, 31.156, 35.37, 39.653, 43.9, 48.026, 51.973, 55.707, 59.224, 62.547, 65.723, 68.81, 71.874, 74.973, 78.148, 81.407, 84.717, 87.992, 91.098, 93.848, 96.026, 97.412, 97.826, 97.203, 95.68, 93.724, 92.296, 93.056, 98.616, 100.0], 10: [66.224, 52.201, 44.828, 40.167, 36.08, 31.624, 26.593, 21.187, 15.786, 10.791, 6.541, 3.261, 1.052, 0.0, 0.0, 0.264, 1.396, 2.879, 4.516, 6.147, 7.664, 9.009, 10.18, 11.223, 12.217, 13.272, 14.503, 16.026, 17.938, 20.309, 23.176, 26.535, 30.342, 34.521, 38.961, 43.537, 48.115, 52.565, 56.779, 60.678, 64.224, 67.42, 70.319, 73.007, 75.601, 78.225, 80.989, 83.961, 87.143, 90.445, 93.669, 96.515, 98.599, 99.521, 98.974, 96.917, 93.839, 91.123, 91.541, 99.92, 100.0], 11: [94.093, 52.397, 37.824, 34.674, 34.347, 32.846, 28.966, 23.024, 16.005, 9.027, 3.029, 0.0, 0.0, 0.0, 0.0, 0.0, 1.188, 4.155, 6.952, 9.301, 11.05, 12.173, 12.755, 12.967, 13.033, 13.2, 13.704, 14.741, 16.45, 18.899, 22.079, 25.913, 30.263, 34.95, 39.775, 44.541, 49.077, 53.254, 57.002, 60.312, 63.242, 65.901, 68.438, 71.015, 73.781, 76.842, 80.239, 83.919, 87.732, 91.434, 94.705, 97.197, 98.595, 98.701, 97.531, 95.415, 93.088, 91.749, 93.049, 98.984, 100.0], 12: [64.169, 52.337, 43.844, 38.568, 35.116, 31.97, 28.045, 22.862, 16.503, 9.448, 2.387, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 3.347, 6.684, 9.368, 11.365, 12.771, 13.779, 14.646, 15.653, 17.064, 19.087, 21.85, 25.383, 29.617, 34.391, 39.48, 44.62, 49.55, 54.046, 57.956, 61.221, 63.89, 66.114, 68.126, 70.2, 72.607, 75.555, 79.137, 83.286, 87.755, 92.133, 95.893, 98.492, 99.512, 98.816, 96.703, 93.99, 91.94, 91.91, 94.546, 98.282, 96.845], 13: [25.887, 52.318, 50.472, 42.307, 35.564, 31.199, 27.707, 23.375, 17.241, 9.278, 0.204, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 3.827, 7.997, 10.996, 12.933, 14.085, 14.832, 15.591, 16.748, 18.602, 21.33, 24.966, 29.405, 34.43, 39.747, 45.031, 49.984, 54.372, 58.065, 61.055, 63.457, 65.487, 67.424, 69.564, 72.159, 75.363, 79.193, 83.5, 87.981, 92.212, 95.72, 98.07, 98.98, 98.418, 96.678, 94.4, 92.503, 92.032, 93.895, 98.527, 100.0], 14: [100.0, 52.533, 0.0, 0.0, 29.312, 42.957, 30.811, 13.731, 6.35, 13.483, 32.233, 55.824, 77.078, 90.703, 94.275, 88.162, 74.782, 57.592, 40.104, 25.139, 14.41, 8.434, 6.708, 8.062, 11.063, 14.399, 17.151, 18.932, 19.878, 20.518, 21.567, 23.697, 27.337, 32.541, 38.96, 45.91, 52.53, 57.986, 61.686, 63.437, 63.529, 62.695, 61.955, 62.369, 64.749, 69.399, 75.96, 83.432, 90.403, 95.46, 97.706, 97.196, 95.092, 93.302, 93.514, 95.797, 97.553, 94.602, 87.74, 100.0, 100.0], 15: [100.0, 52.6, 0.0, 0.0, 27.178, 47.122, 30.015, 10.033, 4.867, 15.242, 32.372, 45.735, 48.143, 37.648, 17.016, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 3.285, 13.153, 18.236, 19.151, 17.432, 15.019, 13.745, 14.909, 19.02, 25.766, 34.16, 42.847, 50.467, 56.004, 59.023, 59.758, 59.028, 57.997, 57.853, 59.476, 63.189, 68.673, 75.066, 81.251, 86.233, 89.501, 91.229, 92.195, 93.383, 95.377, 97.816, 99.301, 98.182, 94.28, 90.701, 92.96, 99.108, 68.756], 16: [100.0, 52.601, 0.0, 0.0, 27.115, 47.247, 29.454, 9.914, 5.55, 15.302, 29.146, 36.541, 31.404, 13.478, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 2.923, 13.612, 18.658, 19.132, 16.944, 14.27, 13.018, 14.428, 18.876, 25.901, 34.415, 43.038, 50.463, 55.775, 58.654, 59.411, 58.879, 58.162, 58.337, 60.16, 63.872, 69.149, 75.215, 81.099, 85.957, 89.354, 91.41, 92.714, 94.009, 95.73, 97.611, 98.636, 97.609, 94.39, 91.222, 92.487, 99.219, 91.656], 17: [100.0, 52.602, 0.0, 0.0, 27.116, 47.246, 29.672, 9.915, 5.27, 15.301, 30.308, 39.614, 36.671, 20.658, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 2.939, 13.548, 18.628, 19.16, 17.003, 14.32, 13.033, 14.405, 18.834, 25.867, 34.412, 43.072, 50.52, 55.831, 58.682, 59.397, 58.827, 58.092, 58.28, 60.141, 63.902, 69.217, 75.293, 81.155, 85.97, 89.33, 91.375, 92.703, 94.039, 95.782, 97.637, 98.602, 97.541, 94.369, 91.275, 92.455, 99.226, 95.065], 18: [100.0, 52.601, 0.0, 0.0, 27.117, 47.245, 29.754, 9.917, 5.163, 15.301, 30.765, 40.845, 38.814, 23.626, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 2.949, 13.517, 18.611, 19.173, 17.034, 14.35, 13.047, 14.399, 18.816, 25.851, 34.409, 43.085, 50.547, 55.859, 58.699, 59.394, 58.803, 58.056, 58.246, 60.125, 63.911, 69.247, 75.332, 81.186, 85.981, 89.319, 91.355, 92.692, 94.049, 95.806, 97.654, 98.59, 97.508, 94.356, 91.3, 92.441, 99.229, 96.824], 19: [100.0, 52.601, 0.0, 0.0, 27.114, 47.25, 29.535, 9.911, 5.452, 15.304, 29.504, 37.422, 32.801, 15.226, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 2.914, 13.616, 18.667, 19.135, 16.934, 14.25, 12.995, 14.411, 18.869, 25.904, 34.424, 43.044, 50.46, 55.764, 58.639, 59.401, 58.88, 58.178, 58.363, 60.187, 63.889, 69.149, 75.2, 81.078, 85.943, 89.357, 91.428, 92.736, 94.019, 95.721, 97.593, 98.628, 97.622, 94.404, 91.212, 92.489, 99.22, 90.365], 20: [100.0, 52.601, 0.0, 0.0, 27.11, 47.257, 29.455, 9.905, 5.565, 15.307, 28.959, 35.872, 29.96, 11.095, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 2.884, 13.688, 18.713, 19.111, 16.857, 14.164, 12.941, 14.406, 18.904, 25.947, 34.441, 43.016, 50.392, 55.682, 58.58, 59.398, 58.943, 58.288, 58.478, 60.259, 63.885, 69.067, 75.076, 80.97, 85.9, 89.392, 91.507, 92.792, 94.0, 95.637, 97.522, 98.658, 97.74, 94.461, 91.12, 92.537, 99.212, 82.952]}

// this is only for plotting the functions
const polynomialXInterval = [-2., -1.,  0.,  1.,  2.,  3.,  4.,  5.,  6.,  7.,  8.,  9., 10.,
  11., 12., 13., 14., 15., 16., 17., 18., 19., 20., 21., 22., 23.,
  24., 25., 26., 27., 28., 29., 30., 31., 32., 33., 34., 35., 36.,
  37., 38., 39., 40., 41., 42., 43., 44., 45., 46., 47., 48., 49.,
  50., 51., 52., 53., 54., 55., 56., 57., 58., 59., 60., 61., 62.]
const polynomialPredsInterval = {1: [-1.356, 0.145, 1.645, 3.145, 4.645, 6.145, 7.645, 9.145, 10.645, 12.145, 13.645, 15.145, 16.646, 18.146, 19.646, 21.146, 22.646, 24.146, 25.646, 27.146, 28.646, 30.146, 31.646, 33.147, 34.647, 36.147, 37.647, 39.147, 40.647, 42.147, 43.647, 45.147, 46.647, 48.147, 49.648, 51.148, 52.648, 54.148, 55.648, 57.148, 58.648, 60.148, 61.648, 63.148, 64.649, 66.149, 67.649, 69.149, 70.649, 72.149, 73.649, 75.149, 76.649, 78.149, 79.649, 81.15, 82.65, 84.15, 85.65, 87.15, 88.65, 90.15, 91.65, 93.15, 94.65], 2: [37.828, 36.072, 34.415, 32.859, 31.404, 30.049, 28.795, 27.641, 26.588, 25.635, 24.783, 24.031, 23.379, 22.829, 22.378, 22.029, 21.779, 21.63, 21.582, 21.634, 21.787, 22.04, 22.394, 22.848, 23.403, 24.058, 24.814, 25.67, 26.627, 27.684, 28.842, 30.1, 31.459, 32.918, 34.478, 36.138, 37.899, 39.76, 41.722, 43.784, 45.947, 48.21, 50.574, 53.038, 55.603, 58.268, 61.034, 63.9, 66.867, 69.934, 73.102, 76.37, 79.739, 83.208, 86.778, 90.448, 94.219, 98.09, 102.062, 106.135, 110.307, 114.581, 118.954, 123.429, 128.004], 3: [81.779, 72.321, 63.545, 55.431, 47.963, 41.121, 34.888, 29.245, 24.173, 19.655, 15.672, 12.206, 9.239, 6.752, 4.728, 3.147, 1.992, 1.244, 0.885, 0.897, 1.262, 1.961, 2.975, 4.288, 5.88, 7.733, 9.828, 12.149, 14.676, 17.391, 20.275, 23.312, 26.481, 29.766, 33.147, 36.606, 40.126, 43.688, 47.273, 50.864, 54.441, 57.988, 61.485, 64.914, 68.258, 71.497, 74.613, 77.589, 80.406, 83.045, 85.488, 87.718, 89.715, 91.462, 92.941, 94.132, 95.018, 95.581, 95.801, 95.662, 95.144, 94.23, 92.901, 91.138, 88.924], 4: [76.729, 68.433, 60.68, 53.46, 46.764, 40.583, 34.908, 29.728, 25.033, 20.812, 17.055, 13.751, 10.887, 8.453, 6.436, 4.824, 3.605, 2.765, 2.291, 2.17, 2.388, 2.93, 3.784, 4.933, 6.363, 8.058, 10.004, 12.184, 14.582, 17.181, 19.966, 22.918, 26.021, 29.257, 32.608, 36.056, 39.582, 43.168, 46.795, 50.442, 54.092, 57.722, 61.315, 64.847, 68.3, 71.652, 74.881, 77.965, 80.884, 83.613, 86.131, 88.416, 90.442, 92.188, 93.63, 94.742, 95.502, 95.884, 95.863, 95.415, 94.513, 93.132, 91.245, 88.827, 85.85], 5: [73.487, 66.179, 59.222, 52.629, 46.414, 40.587, 35.158, 30.132, 25.516, 21.314, 17.526, 14.154, 11.196, 8.649, 6.51, 4.772, 3.43, 2.475, 1.898, 1.688, 1.835, 2.325, 3.144, 4.28, 5.716, 7.436, 9.423, 11.661, 14.13, 16.813, 19.689, 22.739, 25.943, 29.281, 32.732, 36.274, 39.886, 43.548, 47.237, 50.933, 54.613, 58.257, 61.843, 65.35, 68.758, 72.046, 75.194, 78.183, 80.994, 83.607, 86.006, 88.172, 90.09, 91.742, 93.116, 94.195, 94.968, 95.422, 95.545, 95.328, 94.762, 93.84, 92.554, 90.9, 88.875], 6: [83.626, 72.244, 62.34, 53.726, 46.234, 39.718, 34.052, 29.123, 24.839, 21.118, 17.892, 15.107, 12.716, 10.682, 8.978, 7.581, 6.475, 5.65, 5.098, 4.815, 4.8, 5.052, 5.572, 6.361, 7.419, 8.748, 10.344, 12.205, 14.325, 16.699, 19.315, 22.161, 25.221, 28.479, 31.913, 35.5, 39.214, 43.026, 46.906, 50.822, 54.741, 58.627, 62.445, 66.16, 69.738, 73.145, 76.351, 79.326, 82.045, 84.489, 86.642, 88.495, 90.048, 91.308, 92.293, 93.031, 93.562, 93.942, 94.239, 94.541, 94.951, 95.593, 96.613, 98.18, 100.485], 7: [63.672, 61.195, 57.333, 52.541, 47.192, 41.589, 35.972, 30.53, 25.402, 20.692, 16.467, 12.769, 9.617, 7.012, 4.941, 3.382, 2.305, 1.675, 1.456, 1.611, 2.103, 2.9, 3.97, 5.287, 6.828, 8.573, 10.509, 12.623, 14.908, 17.358, 19.969, 22.739, 25.666, 28.746, 31.976, 35.349, 38.857, 42.487, 46.222, 50.041, 53.918, 57.823, 61.719, 65.566, 69.321, 72.937, 76.366, 79.56, 82.472, 85.059, 87.287, 89.13, 90.576, 91.632, 92.327, 92.717, 92.893, 92.985, 93.169, 93.677, 94.805, 96.917, 100.462, 105.981, 114.117], 8: [56.576, 57.643, 55.95, 52.356, 47.554, 42.086, 36.373, 30.729, 25.381, 20.485, 16.139, 12.396, 9.271, 6.754, 4.818, 3.42, 2.513, 2.045, 1.966, 2.228, 2.788, 3.61, 4.662, 5.922, 7.373, 9.003, 10.808, 12.785, 14.938, 17.268, 19.78, 22.479, 25.365, 28.439, 31.696, 35.126, 38.717, 42.449, 46.297, 50.23, 54.215, 58.209, 62.171, 66.053, 69.806, 73.384, 76.739, 79.828, 82.614, 85.065, 87.162, 88.894, 90.267, 91.302, 92.037, 92.53, 92.862, 93.134, 93.472, 94.027, 94.972, 96.504, 98.842, 102.224, 106.906], 9: [-40.707, 13.744, 41.46, 51.861, 51.834, 46.255, 38.428, 30.46, 23.564, 18.313, 14.833, 12.973, 12.417, 12.782, 13.684, 14.777, 15.786, 16.515, 16.855, 16.773, 16.305, 15.541, 14.609, 13.658, 12.843, 12.311, 12.193, 12.59, 13.569, 15.163, 17.368, 20.144, 23.425, 27.119, 31.121, 35.318, 39.597, 43.857, 48.01, 51.993, 55.764, 59.31, 62.644, 65.796, 68.817, 71.761, 74.681, 77.614, 80.575, 83.543, 86.454, 89.2, 91.633, 93.577, 94.855, 95.326, 94.951, 93.869, 92.515, 91.759, 93.093, 98.857, 112.518, 139.012, 185.149], 10: [132.972, 88.755, 64.797, 52.186, 45.221, 40.498, 36.199, 31.554, 26.43, 21.042, 15.747, 10.915, 6.844, 3.73, 1.649, 0.574, 0.392, 0.933, 1.997, 3.383, 4.908, 6.428, 7.841, 9.101, 10.209, 11.212, 12.189, 13.244, 14.488, 16.03, 17.961, 20.349, 23.224, 26.583, 30.383, 34.547, 38.97, 43.528, 48.09, 52.53, 56.736, 60.629, 64.164, 67.336, 70.186, 72.789, 75.25, 77.684, 80.196, 82.858, 85.684, 88.608, 91.471, 94.02, 95.931, 96.863, 96.557, 94.991, 92.62, 90.695, 91.72, 100.039, 122.607, 169.968, 257.487], 11: [399.332, 197.443, 96.47, 52.409, 37.261, 34.255, 34.229, 32.943, 29.128, 23.13, 15.997, 8.91, 2.854, -1.525, -3.949, -4.47, -3.384, -1.14, 1.76, 4.833, 7.677, 10.012, 11.69, 12.697, 13.136, 13.194, 13.116, 13.162, 13.579, 14.569, 16.27, 18.745, 21.978, 25.877, 30.293, 35.035, 39.894, 44.669, 49.184, 53.313, 56.989, 60.213, 63.048, 65.61, 68.048, 70.525, 73.181, 76.112, 79.344, 82.81, 86.354, 89.732, 92.648, 94.796, 95.927, 95.931, 94.916, 93.284, 91.767, 91.407, 93.434, 98.976, 108.561, 121.305, 133.693], 12: [17.147, 53.508, 58.323, 52.332, 44.935, 39.22, 35.21, 31.827, 27.954, 22.924, 16.632, 9.447, 2.035, -4.839, -10.477, -14.368, -16.254, -16.138, -14.254, -11.007, -6.899, -2.451, 1.87, 5.7, 8.817, 11.153, 12.782, 13.9, 14.78, 15.732, 17.053, 18.985, 21.686, 25.202, 29.469, 34.323, 39.519, 44.77, 49.787, 54.323, 58.206, 61.372, 63.874, 65.881, 67.65, 69.486, 71.685, 74.472, 77.939, 82.003, 86.383, 90.623, 94.162, 96.447, 97.096, 96.078, 93.861, 91.468, 90.302, 91.612, 95.342, 98.08, 89.718, 48.3, -67.56], 13: [-228.563, -34.557, 36.298, 52.321, 48.748, 41.371, 35.468, 31.383, 27.759, 23.219, 17.056, 9.349, 0.779, -7.661, -14.951, -20.267, -23.114, -23.373, -21.271, -17.302, -12.121, -6.429, -0.869, 4.056, 8.029, 10.94, 12.875, 14.076, 14.887, 15.696, 16.871, 18.707, 21.386, 24.961, 29.347, 34.345, 39.672, 45.006, 50.037, 54.51, 58.269, 61.276, 63.625, 65.52, 67.247, 69.12, 71.427, 74.361, 77.971, 82.126, 86.512, 90.669, 94.063, 96.204, 96.79, 95.849, 93.847, 91.703, 90.626, 91.683, 94.967, 98.221, 94.724, 70.267, -1.024], 14: [8975.289, 3140.538, 798.348, 52.537, -71.248, -22.05, 29.209, 43.154, 30.866, 13.564, 6.154, 13.558, 32.842, 57.1, 78.999, 93.114, 96.938, 90.813, 77.188, 59.585, 41.6, 26.135, 14.971, 8.668, 6.739, 8.003, 11.003, 14.39, 17.208, 19.04, 20.004, 20.624, 21.624, 23.692, 27.277, 32.454, 38.885, 45.886, 52.585, 58.128, 61.893, 63.66, 63.697, 62.726, 61.771, 61.917, 64.01, 68.391, 74.735, 82.059, 88.937, 93.92, 96.051, 95.329, 92.897, 90.727, 90.68, 93.102, 95.682, 94.255, 88.805, 100.241, 206.905, 614.531, 1779.84], 15: [17717.389, 5906.015, 1400.084, 52.597, -145.155, -54.717, 27.257, 46.963, 30.138, 10.181, 4.797, 15.167, 32.969, 47.872, 52.532, 44.583, 26.266, 2.722, -20.096, -37.2, -45.664, -44.962, -36.648, -23.615, -9.204, 3.634, 12.915, 17.899, 19.038, 17.668, 15.56, 14.429, 15.533, 19.413, 25.84, 33.935, 42.44, 50.054, 55.764, 59.077, 60.13, 59.627, 58.637, 58.297, 59.504, 62.668, 67.599, 73.575, 79.575, 84.62, 88.112, 90.05, 91.01, 91.841, 93.159, 94.856, 95.973, 95.284, 92.688, 90.687, 93.58, 98.927, 70.746, -124.174, -847.67], 16: [24631.919, 7951.05, 1810.576, 52.601, -184.837, -68.727, 27.101, 47.277, 28.736, 9.885, 6.502, 15.318, 24.91, 24.904, 10.716, -15.797, -48.28, -78.786, -100.433, -109.133, -104.178, -87.851, -64.397, -38.745, -15.334, 2.729, 14.061, 18.955, 18.99, 16.449, 13.688, 12.613, 14.332, 19.051, 26.175, 34.572, 42.918, 50.044, 55.191, 58.154, 59.263, 59.254, 59.049, 59.504, 61.212, 64.374, 68.788, 73.946, 79.195, 83.931, 87.745, 90.501, 92.306, 93.405, 94.041, 94.346, 94.31, 93.851, 92.961, 91.988, 92.4, 99.204, 127.955, 222.672, 496.992], 17: [22381.569, 7308.245, 1686.388, 52.602, -173.941, -65.174, 27.098, 47.282, 29.12, 9.88, 6.008, 15.32, 26.944, 30.249, 19.827, -3.443, -33.966, -64.136, -86.975, -97.969, -95.835, -82.3, -61.196, -37.241, -14.853, 2.74, 13.964, 18.919, 19.042, 16.537, 13.747, 12.605, 14.265, 18.965, 26.119, 34.579, 42.991, 50.152, 55.286, 58.19, 59.221, 59.149, 58.924, 59.417, 61.208, 64.462, 68.939, 74.101, 79.295, 83.945, 87.693, 90.444, 92.308, 93.489, 94.153, 94.386, 94.218, 93.698, 92.927, 92.11, 92.319, 99.222, 135.362, 272.894, 709.693], 18: [9709.303, 3639.625, 967.76, 52.602, -108.945, -43.556, 27.118, 47.241, 31.491, 9.92, 2.924, 15.298, 40.063, 65.407, 80.833, 80.757, 65.379, 39.481, 10.152, -15.619, -32.777, -39.153, -35.461, -24.591, -10.485, 3.015, 13.092, 18.456, 19.388, 17.383, 14.554, 12.97, 14.098, 18.475, 25.667, 34.483, 43.375, 50.89, 56.066, 58.654, 59.127, 58.491, 57.946, 58.52, 60.78, 64.706, 69.765, 75.153, 80.116, 84.207, 87.386, 89.906, 92.03, 93.769, 94.815, 94.818, 93.879, 92.823, 92.591, 92.779, 91.941, 99.293, 182.195, 602.378, 2144.522], 19: [13671.728, 4768.792, 1185.394, 52.601, -127.97, -49.767, 27.115, 47.247, 30.841, 9.915, 3.742, 15.302, 36.723, 56.649, 65.963, 60.686, 42.236, 15.908, -11.407, -33.434, -46.055, -47.98, -40.565, -27.013, -11.285, 2.975, 13.245, 18.528, 19.324, 17.249, 14.441, 12.937, 14.145, 18.56, 25.733, 34.488, 43.311, 50.786, 55.969, 58.607, 59.152, 58.576, 58.053, 58.601, 60.8, 64.657, 69.668, 75.052, 80.051, 84.195, 87.415, 89.937, 92.03, 93.731, 94.767, 94.803, 93.917, 92.877, 92.599, 92.741, 91.966, 99.287, 180.795, 594.991, 2122.059], 20: [15862.408, 5400.692, 1308.693, 52.602, -139.026, -53.426, 27.112, 47.254, 30.446, 9.908, 4.25, 15.305, 34.59, 50.974, 56.191, 47.307, 26.581, -0.276, -26.437, -46.053, -55.618, -54.452, -44.38, -28.864, -11.914, 2.937, 13.367, 18.591, 19.276, 17.135, 14.336, 12.893, 14.171, 18.626, 25.79, 34.498, 43.261, 50.695, 55.876, 58.555, 59.167, 58.653, 58.161, 58.695, 60.839, 64.623, 69.579, 74.946, 79.974, 84.174, 87.444, 89.982, 92.047, 93.7, 94.71, 94.773, 93.951, 92.945, 92.62, 92.691, 91.995, 99.282, 177.971, 576.544, 2047.582]}

// for altering data points
const changeDataPolynomialPoints= data => {

  const fitIntoInterval = (num,lower,upper) => {
    let val = num
    if (num<lower){
      val = lower
    } else if (num>upper) {
      val = upper
    }
    return val
  }
  
  let newY = polynomialDataY.map(y => fitIntoInterval(getRandomNumber(y-2,y+2,true),0,100))
  let newX = polynomialDataX.map(x => fitIntoInterval(getRandomNumber(x-2,x+2,true),0,60))
  
  return ([{
    x: newX,
    y: newY,
    type: 'scatter',
    mode: `markers`,
    name: "polynomial regression",
    showlegend: false,
    hoverlabel: {
      font: {color: "#fff"}
    },
    hovertemplate:
            "hours studied: %{x}<br>" +
            "points achieved: %{y}<br>" +
            "<extra></extra>",
    marker: { 
      size:15,
      color: colors[0],
      line: {
        color: '#fff',
        width: 0.5
    }},
    },data[1]])
  }

let ab = 0

const getMSEMetricForDegree = degree => {

  const calculateMSEMetric = data => {
  
    const MSE = (y_true,y_pred) => {
      let totalMSE = 0
      for (const idx of Array(y_true.length).keys()) {
          const current_y_true = y_true[idx]
          const current_y_pred = y_pred[idx]
          const difference = current_y_true - current_y_pred
          const squared = Math.pow(difference,2)
          totalMSE+=squared
      }
      totalMSE = Math.sqrt(totalMSE / y_true.length)
      return totalMSE
    }

    let predictions = []
    for (const x of data[0].x) {
      predictions.push(polynomialPredsXTest[degree][x])
    }

    let mse = MSE(data[0].y,predictions)
  
    return parseFloat(mse.toFixed(2))
  }

  return calculateMSEMetric
}

const getRelativeDifferenceForDegree = (degree, initialMSE) => {

  const calculateMSE = getMSEMetricForDegree(degree)

  const calculateRelativeDifference = data => {
  
    const newMSE = parseFloat(calculateMSE(data))

    const relativeDifference = Math.abs((newMSE/initialMSE)-1)*10
  
    return relativeDifference.toFixed(2)+"%"
  }

  return calculateRelativeDifference

}

const underfitData = [{
  x: polynomialDataX,
  y: polynomialDataY,
  type: `scatter`,
  mode: "markers",
  name: "data points",
  showlegend: false,
  hoverlabel: {
    font: {color: "#fff"}
  },
  hovertemplate:
          "hours studied: %{x}<br>" +
          "points achieved: %{y}<br>" +
          "<extra></extra>",
  marker: { 
    size:15,
    color: colors[0],
    line: {
      color: '#fff',
      width: 0.5
  }},
},
{
  x: polynomialXInterval,
  y: polynomialPredsInterval[1],
  type: `scatter`,
  mode: "lines",
  name: "predictions",
  showlegend: false,
  hoverlabel: {
    font: {color: "#000"}
  },
  hovertemplate:
          "hours studied: %{x}<br>" +
          "points achieved: %{y}<br>" +
          "<extra></extra>",
  marker: { 
    size:15,
    color: colors[1],
    line: {
      color: '#fff',
      width: 0.5
  }},
}]

const underfitDataWithLegend = [{
  x: polynomialDataX,
  y: polynomialDataY,
  type: `scatter`,
  mode: "markers",
  name: "data points",
  showlegend: true,
  hoverlabel: {
    font: {color: "#fff"}
  },
  hovertemplate:
          "hours studied: %{x}<br>" +
          "points achieved: %{y}<br>" +
          "<extra></extra>",
  marker: { 
    size:15,
    color: colors[0],
    line: {
      color: '#fff',
      width: 0.5
  }},
},
{
  x: polynomialXInterval,
  y: polynomialPredsInterval[1],
  type: `scatter`,
  mode: "lines",
  name: "predictions",
  showlegend: true,
  hoverlabel: {
    font: {color: "#000"}
  },
  hovertemplate:
          "hours studied: %{x}<br>" +
          "points achieved: %{y}<br>" +
          "<extra></extra>",
  marker: { 
    size:15,
    color: colors[1],
    line: {
      color: '#fff',
      width: 0.5
  }},
}]

const wellFitData = [{
  x: polynomialDataX,
  y: polynomialDataY,
  type: `scatter`,
  mode: "markers",
  name: "polynomial points",
  showlegend: false,
  hoverlabel: {
    font: {color: "#fff"}
  },
  hovertemplate:
          "hours studied: %{x}<br>" +
          "points achieved: %{y}<br>" +
          "<extra></extra>",
  marker: { 
    size:15,
    color: colors[0],
    line: {
      color: '#fff',
      width: 0.5
  }},
},
{
  x: polynomialXInterval,
  y: polynomialPredsInterval[4],
  type: `scatter`,
  mode: "lines",
  name: "polynomial regression",
  showlegend: false,
  hoverlabel: {
    font: {color: "#000"}
  },
  hovertemplate:
          "hours studied: %{x}<br>" +
          "points achieved: %{y}<br>" +
          "<extra></extra>",
  marker: { 
    size:15,
    color: colors[1],
    line: {
      color: '#fff',
      width: 0.5
  }},
}]

const overFitData = [{
  x: polynomialDataX,
  y: polynomialDataY,
  type: `scatter`,
  mode: "markers",
  name: "polynomial points",
  showlegend: false,
  hoverlabel: {
    font: {color: "#fff"}
  },
  hovertemplate:
          "hours studied: %{x}<br>" +
          "points achieved: %{y}<br>" +
          "<extra></extra>",
  marker: { 
    size:15,
    color: colors[0],
    line: {
      color: '#fff',
      width: 0.5
  }},
},
{
  x: polynomialXInterval,
  y: polynomialPredsInterval[15],
  type: `scatter`,
  mode: "lines",
  name: "polynomial regression",
  showlegend: false,
  hoverlabel: {
    font: {color: "#000"}
  },
  hovertemplate:
          "hours studied: %{x}<br>" +
          "points achieved: %{y}<br>" +
          "<extra></extra>",
  marker: { 
    size:15,
    color: colors[1],
    line: {
      color: '#fff',
      width: 0.5
  }},
}]

const polynomialLayout = {
  xaxis: {
          range: [-2, 62],
          title:"number of hours studied",
          showgrid: true,
          gridcolor: "rgba(255,255,255,0.05)",
          zeroline: true,
          fixedrange: true,
          showline: true,
          autotick: true,
          ticks: '',
          showticklabels: true
          },
  yaxis: {
          range: [-10, 110],
          title: "number of points achieved",
          gridcolor: "rgba(255,255,255,0.05)",
          zeroline: true,
          fixedrange: true,
          showline: true,
          autotick: true,
          ticks: '',
          showticklabels: true
          },
  margin: { t: 80, r: 80, b: 80, l: 80 },
  paper_bgcolor: `rgba(0, 0, 0, 0)`,
  plot_bgcolor: `rgba(0, 0, 0, 0)`,
  font: {
    color: `rgba(255,255,255,0.5)`,
    size: 16,
  }
}

export const polynomialData = {
  data: [{
    x: polynomialDataX,
    y: polynomialDataY,
    type: `scatter`,
    mode: "markers",
    name: "polynomial points",
    showlegend: false,
    hoverlabel: {
      font: {color: "#fff"}
    },
    hovertemplate:
            "hours studied: %{x}<br>" +
            "points achieved: %{y}<br>" +
            "<extra></extra>",
    marker: { 
      size:15,
      color: colors[0],
      line: {
        color: '#fff',
        width: 0.5
    }},
  }],
  layout: polynomialLayout,
  props: {
    yAxisTitle: "number of points achieved",
    xAxisTitle: "number of hours studied",
    plotTitle: "exam results",
    fixedRange:true
  }
}

export const polynomialPredUnderFit = {
  data: underfitData,
  layout: {...polynomialLayout, annotations: [
    {
      x: 20,
      y: 105,
      xref: 'x',
      yref: 'y',
      showarrow:false,
      text: 'RMSE: 19.8',
      ax: 0,
      ay: -40
    }
  ]},
  props: {
    yAxisTitle: "number of points achieved",
    xAxisTitle: "number of hours studied",
    plotTitle: "exam results",
    fixedRange:true
  }
}

export const polynomialPredUnderFitNoAnnotations = {
  data: underfitDataWithLegend,
  layout: polynomialLayout,
  props: {
    yAxisTitle: "number of points achieved",
    xAxisTitle: "number of hours studied",
    plotTitle: "exam results",
    fixedRange:true
  }
}

export const polynomialPredFit = {
  data: wellFitData,
  layout: {...polynomialLayout, annotations: [
    {
      x: 20,
      y: 105,
      xref: 'x',
      yref: 'y',
      showarrow:false,
      text: 'RMSE: 7.68',
      ax: 0,
      ay: -40
    }
  ]},
  props: {
    yAxisTitle: "number of points achieved",
    xAxisTitle: "number of hours studied",
    plotTitle: "exam results",
    fixedRange:true
  }
}

export const polynomialPredOverFit = {
  data: overFitData,
  layout: {...polynomialLayout, annotations: [
    {
      x: 20,
      y: 105,
      xref: 'x',
      yref: 'y',
      showarrow:false,
      text: 'RMSE: 4.93',
      ax: 0,
      ay: -40
    }
  ]},
  props: {
    yAxisTitle: "number of points achieved",
    xAxisTitle: "number of hours studied",
    plotTitle: "exam results",
    fixedRange:true
  }
}

export const polynomialPredUnderFitInteractive = {
  data: underfitData,
  layout: polynomialLayout,
  props: {
    yAxisTitle: "number of points achieved",
    xAxisTitle: "number of hours studied",
    plotTitle: "exam results",
    changeDataFunctions: {"change data": changeDataPolynomialPoints},
    metricInfo: {
                  "RMSE": getMSEMetricForDegree(1),
                  "R.DIFF": getRelativeDifferenceForDegree(1,19.8)
                },
    fixedRange:true
  }
}

// for changing poly degree
let currentPolynomialDegree = 1

const getCurrentPolynomialDegree = () => (currentPolynomialDegree)

const getPolynomialDegreeAdjuster = increment => {
  const changeDataPolynomialDegree = (data) => {

    if (increment==true) {
      if (currentPolynomialDegree==20){
        currentPolynomialDegree=1
      } else {
        currentPolynomialDegree+=1
      }
    } else if (currentPolynomialDegree==1) {
      currentPolynomialDegree=20
    } else {
      currentPolynomialDegree-=1
    }
  
    let newY = polynomialPredsInterval[currentPolynomialDegree]
    
    return ([data[0],{
      x: polynomialXInterval,
      y: newY,
      type: 'scatter',
      mode: `lines`,
      name: 'predictions',
      showlegend: false,
      hoverlabel: {
        font: {color: "#000"}
      },
      hovertemplate:
              "hours studied: %{x}<br>" +
              "points achieved: %{y}<br>" +
              "<extra></extra>",
      marker: { 
        size:15,
        color: colors[1],
        line: {
          color: '#fff',
          width: 0.5
      }},
      }])
    }
    return changeDataPolynomialDegree
}


export const polynomialPredDegreeInteractive= {
  data: underfitData,
  layout: polynomialLayout,
  props: {
    yAxisTitle: "number of points achieved",
    xAxisTitle: "number of hours studied",
    plotTitle: "exam results",
    changeDataFunctions: {
                        "decrement degree": getPolynomialDegreeAdjuster(false),
                        "increment degree": getPolynomialDegreeAdjuster(true)

                        },
    metricInfo: {
                  "degree": getCurrentPolynomialDegree,
                },
    fixedRange:true
  }
}

export const polynomialPredFitInteractive = {
  data: wellFitData,
  layout: polynomialLayout,
  props: {
    yAxisTitle: "number of points achieved",
    xAxisTitle: "number of hours studied",
    plotTitle: "exam results",
    changeDataFunctions: {"change data": changeDataPolynomialPoints},
    metricInfo: {
                "RMSE": getMSEMetricForDegree(4),
                "R.DIFF": getRelativeDifferenceForDegree(4,7.68)
                },
    fixedRange:true
  }
}

export const polynomialPredOverFitInteractive = {
  data: overFitData,
  layout: polynomialLayout,
  props: {
    yAxisTitle: "number of points achieved",
    xAxisTitle: "number of hours studied",
    plotTitle: "exam results",
    changeDataFunctions: {"change data": changeDataPolynomialPoints},
    metricInfo: {
                  "RMSE": getMSEMetricForDegree(15),
                  "R.DIFF": getRelativeDifferenceForDegree(15,4.93)
                },
    fixedRange:true
  }
}

const exponentialX = [-5.  , -4.75, -4.5 , -4.25, -4.  , -3.75, -3.5 , -3.25, -3.  ,
  -2.75, -2.5 , -2.25, -2.  , -1.75, -1.5 , -1.25, -1.  , -0.75,
  -0.5 , -0.25,  0.  ,  0.25,  0.5 ,  0.75,  1.  ,  1.25,  1.5 ,
   1.75,  2.  ,  2.25,  2.5 ,  2.75,  3.  ,  3.25,  3.5 ,  3.75,
   4.  ,  4.25,  4.5 ,  4.75, 5]
const exponentialYOne =  [0.007, 0.009, 0.011, 0.014, 0.018, 0.024, 0.03, 0.039, 0.05, 0.064, 0.082, 0.105, 0.135, 0.174, 0.223, 0.287, 0.368, 0.472, 0.607, 0.779, 1.0, 1.284, 1.649, 2.117, 2.718, 3.49, 4.482, 5.755, 7.389, 9.488, 12.182, 15.643, 20.086, 25.79, 33.115, 42.521, 54.598, 70.105, 90.017, 115.584]
const exponentialYTwo = [115.584, 90.017, 70.105, 54.598, 42.521, 33.115, 25.79, 20.086, 15.643, 12.182, 9.488, 7.389, 5.755, 4.482, 3.49, 2.718, 2.117, 1.649, 1.284, 1.0, 0.779, 0.607, 0.472, 0.368, 0.287, 0.223, 0.174, 0.135, 0.105, 0.082, 0.064, 0.05, 0.039, 0.03, 0.024, 0.018, 0.014, 0.011, 0.009, 0.007]

export const biasVarianceTradeoff = {
  data: [
    {
      x: exponentialX ,
      y: exponentialYOne,
      type: `scatter`,
      mode: "lines",
      name: "bias",
      showlegend: true,
      hoverlabel: {
        font: {color: "#000"}
      },
      hovertemplate:
              "<extra></extra>",
      marker: { 
        size:15,
        color: colors[0],
        line: {
          color: '#fff',
          width: 0.5
        }
      }
    },
    {
      x: exponentialX ,
      y: exponentialYTwo,
      type: `scatter`,
      mode: "lines",
      name: "variance",
      showlegend: true,
      hoverlabel: {
        font: {color: "#fff"}
      },
      hovertemplate:
              "<extra></extra>",
      marker: { 
        size:15,
        color: colors[1],
        line: {
          color: '#fff',
          width: 0.5
      }
    },
  }
  ],
  layout: {
    xaxis: {
      visible: true,
      showgrid: true,
      gridcolor: "rgba(255,255,255,0.05)",
      ticks: '',
      showticklabels: false,
      zeroline: false,
      showline: false,
      title: "Model Complexity",
      fixedrange:true
    },
    yaxis: {
      visible: true,
      showgrid: true,
      gridcolor: "rgba(255,255,255,0.05)",
      ticks: '',
      showticklabels: false,
      fixedrange:true
    },
  },
  props: {
    plotTitle: "The Tradeoff",
    fixedRange:true
  }
}

const trueRelationshipY = [58.596, 54.314, 50.   , 45.686, 41.404, 37.186, 33.063, 29.067,
  25.227, 21.572, 18.129, 14.923, 11.98 ,  9.32 ,  6.963,  4.927,
   3.228,  1.877,  0.886,  0.26 ,  0.006,  0.125,  0.616,  1.475,
   2.696,  4.27 ,  6.185,  8.427, 10.978, 13.822, 16.934, 20.294,
  23.875, 27.651, 31.594, 35.674, 39.861, 44.123, 48.429, 52.748,
  57.045, 61.29 , 65.451, 69.496, 73.396, 77.122, 80.645, 83.94 ,
  86.982, 89.747, 92.216, 94.371, 96.194, 97.673, 98.796, 99.555,
  99.944, 99.961, 99.606, 98.88 , 97.79 , 96.343, 94.55 , 92.426,
  89.984]

const polynomialDataYNoiseless = [45.686, 33.063, 29.067, 21.572, 14.923,  4.27 ,  8.427,  8.427,
  10.978, 16.934, 27.651, 31.594, 35.674, 35.674, 39.861, 48.429,
  57.045, 61.29 , 77.122, 89.747, 89.747, 92.216, 92.216, 96.194,
  98.796, 99.944, 99.606, 98.88 , 97.79 , 96.343] 


let noiseIsPresent = true

const changeDataNoise = data => {
  noiseIsPresent = !noiseIsPresent

  let newY
  if (noiseIsPresent) {
    newY = polynomialDataY
  } else {
    newY = polynomialDataYNoiseless
  }
  return ([{
    x: polynomialDataX,
    y: newY,
    type: 'scatter',
    mode: `markers`,
    name: "data points",
    showlegend: true,
    hoverlabel: {
      font: {color: "#fff"}
    },
    hovertemplate:
            "hours studied: %{x}<br>" +
            "points achieved: %{y}<br>" +
            "<extra></extra>",
    marker: { 
      size:15,
      color: colors[0],
      line: {
        color: '#fff',
        width: 0.5
    }},
    },data[1]])
}

export const trueRelationshipInteractive = {
  data: [
    {
      x: polynomialDataX,
      y: polynomialDataY,
      type: `scatter`,
      mode: "markers",
      name: "data points",
      showlegend: true,
      hoverlabel: {
        font: {color: "#000"}
      },
      hovertemplate:
            "hours studied: %{x}<br>" +
            "points achieved: %{y}<br>" +
            "<extra></extra>",
      marker: { 
        size:15,
        color: colors[0],
        line: {
          color: '#fff',
          width: 0.5
        }
      }
    },
    {
      x: polynomialXInterval ,
      y: trueRelationshipY,
      type: `scatter`,
      mode: "lines",
      name: "true relationship",
      showlegend: true,
      hoverlabel: {
        font: {color: "#fff"}
      },
      hovertemplate:
              "<extra></extra>",
      marker: { 
        size:15,
        color: colors[3],
        line: {
          color: '#fff',
          width: 0.5
      }
    },
  }
  ],
  layout: polynomialLayout,
  props: {
    fixedRange:true,
    changeDataFunctions: {"toggle noise": changeDataNoise},
  }
}